/**
 * Reusable grid/list view toggle used across Workspace, Dashboards,
 * Templates, and Gallery pages. Persists preference per-scope in
 * localStorage.
 */
import React from "react";
import { LayoutGrid, List } from "lucide-react";

const KEY_PREFIX = "analyzio.view_mode.";

export function useViewMode(scope, defaultMode = "tiles") {
    const key = KEY_PREFIX + scope;
    const [mode, setMode] = React.useState(() => {
        try { return localStorage.getItem(key) || defaultMode; }
        catch { return defaultMode; }
    });
    const setPersisted = (m) => {
        setMode(m);
        try { localStorage.setItem(key, m); } catch { /* noop */ }
    };
    return [mode, setPersisted];
}

export default function ViewToggle({ value, onChange, testIdPrefix = "view" }) {
    return (
        <div className="inline-flex items-center border border-border rounded-sm overflow-hidden" data-testid={`${testIdPrefix}-toggle`}>
            <button onClick={() => onChange("tiles")}
                    title="Tiles view"
                    className={`h-8 px-2.5 flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-wider transition-colors ${
                        value === "tiles" ? "bg-secondary text-foreground" : "text-muted-foreground hover:bg-secondary/50"
                    }`}
                    data-testid={`${testIdPrefix}-tiles`}>
                <LayoutGrid className="h-3.5 w-3.5" />
                <span>Tiles</span>
            </button>
            <button onClick={() => onChange("details")}
                    title="Details (list) view"
                    className={`h-8 px-2.5 flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-wider border-l border-border transition-colors ${
                        value === "details" ? "bg-secondary text-foreground" : "text-muted-foreground hover:bg-secondary/50"
                    }`}
                    data-testid={`${testIdPrefix}-details`}>
                <List className="h-3.5 w-3.5" />
                <span>Details</span>
            </button>
        </div>
    );
}
